import axios from 'axios'
import { httpNotification } from '../notification'
import keycloak from '../../keycloak'

export default class Http {
  baseURL

  constructor(baseURL) {
    this.baseURL = baseURL
    return this.create()
  }

  create() {
    const http = axios.create({
      baseURL: this.baseURL,
      timeout: 120000,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    http.interceptors.request.use(
      config => {
        // config.params = paramInterceptors(config);
        const token = localStorage.getItem('token')

        if (token) config.headers.Authorization = `Bearer ${token}`
        return config
      },
      error => Promise.reject(error)
    )

    http.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.response?.status === 403) {
          localStorage.removeItem('token')
          keycloak.logout()
        }
        if (error.response?.status === 500) {
          httpNotification('error', 'get', 'Erro interno na aplicação!', {
            toastId: 'http-error-500'
          })
        }

        return Promise.reject(error)
      }
    )

    return http
  }
}
